import { useEffect, useState } from "react";
import { TagGroupService } from "../../services/TagGroupService";
import { useTranslation } from "react-i18next";
import { showWarning } from "../../services/ModalService";
import ModalContainer from "../../containers/Modal/ModalContainer";
import AddGroupModal from "./AddGroupModal";
import "./Tags.scss";

export default function TagGroupListModal({ isOpen, closeModal, setIsOpenAddNewGroupModal }) {
  let { t } = useTranslation();
  const [groupList, setGroupList] = useState([]);
  const [group, setGroup] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    TagGroupService.getTagGroups().then((data) => {
      setGroupList(data);
    });
  }, [isFormOpen]);

  function openForm(group) {
    setGroup(group);
    setIsFormOpen(true);
    closeModal();
  }

  function closeForm() {
    setGroup({});
    setIsFormOpen(false);
  }

  function deleteGroup(id) {
    showWarning(t("Are you sure you want to delete this group?"), () => {
      TagGroupService.deleteTagGroup(id).then(() => {
        TagGroupService.getTagGroups().then((data) => {
          setGroupList(data);
        });
      });
    });
  }

  const reopenModalGroupList = () => {
    setIsFormOpen(false);
    setIsOpenAddNewGroupModal(true);
  };

  return (
    <>
      <ModalContainer
        isOpen={isOpen}
        modalTitle={t("Groups List")}
        closeModal={closeModal}
        crossmarkAction={closeModal}
        closeButtonTitle="Close"
        closeButtonAction={closeModal}
        modalSize="lg"
        createButtonAction={() => openForm(group)}
        createButtonTitle={t("Create")}
      >
        <div className="table-scroll-height tags-list" id="scroll-desing">
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: "25%" }}>{t("Name")}</th>
                <th style={{ width: "55%" }}>{t("Description")}</th>
                <th style={{ width: "20%" }}>{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {groupList.map((group) => (
                <tr key={group.id}>
                  <td style={{ width: "25%" }}>{group.name}</td>
                  <td style={{ width: "55%" }}>{!group.description ? "-" : group.description}</td>
                  <td className="text-end buttons-hover" style={{ width: "20%" }}>
                    <button
                      class="action-button "
                      onClick={() => openForm(group)}
                      title={t("Edit")}
                    >
                      {" "}
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      class="action-button  btn-sm"
                      onClick={() => deleteGroup(group.id)}
                      title={t("Delete")}
                    >
                      {" "}
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ModalContainer>
      <AddGroupModal
        isOpen={isFormOpen}
        closeModal={closeForm}
        groupEdit={group}
        onClose={() => {
          setIsFormOpen(false);
          setIsOpenAddNewGroupModal(true);
        }}
        onSubmmitSuccess={reopenModalGroupList}
        modalTitleProp={group && group.id ? "Edit Tag" : "New Tag"}
        buttonTitleProp={group && group.id ? "Edit" : "Create"}
      />
    </>
  );
}
